export enum RequestBodyType {
    FormUrlEncoded,
    Query
}
